import React, { useState, useEffect, useCallback } from 'react';
import ReactLoading from "react-loading";

import FixedContainer from '../../../components/Container';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography, Autocomplete } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { GetFetch, PostFetch, urls } from '../../../services/apiBase';
import axios from 'axios';

const Notification = (props) => {
  
  const sendToDict = {
    allUsers: 'allUsers',
    cluster: 'cluster',
    oneUser: 'oneUser'
  }

  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)

  const [openModal, setOpenModal] = useState(false)

  const [sendTo, setSendTo] = useState(null)

  const [users, setUsers] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [usersload, setUsersLoad] = useState(false)

  const [clusters, setClusters] = useState([])
  const [selectedClusters, setSelectedClusters] = useState(null)

  const [clusterClients, setClusterClients] = useState([])
  const [clusterClientsLoad, setClusterClientsLoad] = useState(false)
  const [openClientsModal, setOpenClientsModal] = useState(false) 
  
  const handleOnChange = (e) => {
    let key = e.target.id
    let value = e.target.value

    setMessage({ ...message, [key]: value })
  }

  const handleOnCloseModal = () => {
    setOpenModal(false)
  }

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem('user'))

      if (sendTo === sendToDict.oneUser) {
        const response = await PostFetch(`/subscription/sendMessageToAEndpoint`,{
          "title": message.title,
          "body": message.body,
          "personne_id": selectedUser.id,
          "text": message.text,
          "username": user.username
        })

      } if (sendTo === sendToDict.cluster)  {
        const response = await PostFetch(`/subscription/sendMessageToATopic`,{
          // const response = await axios.post(`http://localhost:4501/v2/subscription/sendMessageToATopic`,{
          "title": message.title,
          "body": message.body,
          "text": message.text,
          "username": user.username,
          "topic": selectedClusters
        })
      }

      clearValues();

      enqueueSnackbar('Notificação enviada com sucesso!', { variant: 'success' });
      
      setOpenModal(false);
      setLoading(false);

    } catch (error) { 
      enqueueSnackbar('Erro ao enviar a notificação', { variant: 'error' });
      console.log(error)
      
      setOpenModal(false);
      setLoading(false)
    }
  }

  function clearValues() {
    setMessage({
      title: '',
      body: '',
      text: ''
    })
  }

  function validateForm() {
    if (message.title === undefined || message.body === undefined) {
      return true;
    }

    if (message.title.length === 0 || message.body.length === 0) {
      return true;
    }

    if (message.title.length > 100 || message.body.length > 200) {
      return true;
    }

    if (!sendTo) {
      return true;
    }

    return false;
  }

  const getClusterClients = async () => {
    setClusterClientsLoad(true)
    try {
      const response = await GetFetch(`/subscription/clusters/clients/${selectedClusters}`)
      // const response = await axios.get(`http://localhost:4500/subscription/clusters/clients/${selectedClusters}`)
      console.log('getClusterClients', response.data)

      setClusterClients(response.data)
    } catch(error) {
      console.log(error)
      enqueueSnackbar('Erro ao buscar clientes', { variant: 'error' });
    } finally {
      setClusterClientsLoad(false)

    }
  }

  useEffect(() => {
    if (selectedClusters) {
      getClusterClients()
    }
  }, [selectedClusters])
 
  const getClusters = async () => {
    setUsersLoad(true)
    try {
      const response = await GetFetch(`/subscription/clusters`)
      // const response = await axios.get('http://localhost:4500/subscription/clusters')
      console.log('getClusters', response.data)

      setClusters(response.data)
      
    } catch(error) {
      console.log(error)
      enqueueSnackbar('Erro ao buscar investidores', { variant: 'error' });
      setSendTo()
    } finally {
      setUsersLoad(false)

    }
  }

  const getUsers = async () => {
    setUsersLoad(true)
    try {
      const response = await GetFetch(urls.GET_USERS)
      const formated = formatUsers(response.data)
      setUsers(formated)
      
    } catch(error) {
      console.log(error)
      enqueueSnackbar('Erro ao buscar investidores', { variant: 'error' });
      setSendTo()
    } {
      setUsersLoad(false)

    }
  }

  function handleMessages(type) {
    let titleMessage = ''
    switch (type) {
      case 'greaterTitle':
        titleMessage = `Título ultrapassa o limite de 100 caracteres, atual ${message.title.length}`
        enqueueSnackbar(titleMessage, { variant: 'error' });
        
        return ;
        case 'greaterBody':
        titleMessage = `Título ultrapassa o limite de 200 caracteres, atual ${message.title.length}`
        enqueueSnackbar(titleMessage, { variant: 'error' });
        
        return ;
      default:
        break;
    }
  }

  const handleRadioButtonsChange = (event) => {
    setSendTo(event.target.value);

    if (event.target.value === sendToDict.oneUser) {
      setSelectedClusters(null)
    }
  };

  const loadingComponent = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          paddingTop: 2
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  useEffect(() => {
    if (sendTo === sendToDict.oneUser) {
      getUsers()
    }

    if (sendTo === sendToDict.cluster) {
      getClusters()
    }
  }, [sendTo])

  useEffect(() => {
    if((message.title) && (message.title.length > 100)) {
      handleMessages('greaterTitle')
    }

    if((message.body) && (message.body.length > 200)) {
      handleMessages('greaterBody')
    }
  }, [message.title, message.body])

  function formatUsers(users) {
    return users.map((user) => ({label: user.name, id: user.id}))
  }

  const handleUserChange = (event, value) => {
    setSelectedUser(value); 
  };

  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 3 }}>
            Comunicação/Push notification
          </Typography>

          <FormControl sx={{gap: 2, marginBottom: 3}} fullWidth>
            <TextField
              id={`title`}
              label="Título"
              value={message.title}
              onChange={(event) => {
                handleOnChange(event);
              }}
            />

            <TextField
              id={`body`}
              label="Mensagem"
              value={message.body}
              onChange={(event) => {
                handleOnChange(event);
              }}
            />

            <TextField
              id={`text`}
              label="Texto adicional"
              value={message.text}
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel id="demo-controlled-radio-buttons-group">Enviar push notification para:</FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={sendTo}
              onChange={handleRadioButtonsChange}
            >
              <FormControlLabel value={sendToDict.cluster} control={<Radio />} label="Um cluster(Grupo de clientes) " />
              <FormControlLabel value={sendToDict.oneUser} control={<Radio />} label="Investidor específico" />
            </RadioGroup>
          </FormControl>

          {
            usersload 
            ? <ReactLoading type='bubbles' color="#feb049" />
            : (sendTo === sendToDict.oneUser) ? (
              <FormControl fullWidth>
                
                <Autocomplete
                  disablePortal
                  options={users}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => {
                    return option.id === value.id
                  }}
                  value={selectedUser}
                  onChange={handleUserChange}
                  renderInput={(params) => <TextField {...params} label="Selecione o cliente" />}
                />
                
              </FormControl>
            ) : (sendTo === sendToDict.cluster) ? (
              <FormControl fullWidth>
                <InputLabel id="state">Selecione o cluster</InputLabel>
                <Select
                  labelId="Selecione o cluster"
                  id="cluster"
                  label="Selecione o cluster"
                  value={selectedClusters}
                  onChange={e => setSelectedClusters(e.target.value)}
                >
                  {clusters.map(cluster => (
                    <MenuItem value={cluster.id}>{cluster.cluster_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : <></>
          }

          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: selectedClusters ? 'space-between' : 'flex-end',
            gap: 1,
            padding: 2,
            borderRadius: '0 0 8px 8px',
            backgroundColor: '#fff'
          }}>

            {
              (selectedClusters) && (
                <Button disabled={clusterClientsLoad} variant="contained" color={'info'}>
                  <Typography color={'#fff'} onClick={() => setOpenClientsModal(true) }>
                    {clusterClientsLoad ? <CircularProgress color='success' /> : 'Visualizar cluster'}
                  </Typography>
                </Button>
              )
            }
            
            <Button disabled={validateForm()} variant="contained" color={'success'}>
              <Typography color={'#fff'} onClick={() => setOpenModal(true)}>
                {loading? <CircularProgress color='success' /> : 'Enviar'}
              </Typography>
            </Button>
          </Box>
        </Box>

        <Dialog
          open={openModal}
          fullWidth={true}
          maxWidth={"sm"}
          onClose={() => handleOnCloseModal()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Atenção"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{
              loading ? loadingComponent() : `Deseja enviar a notificação?`
            }
              
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={loading} onClick={() => handleOnCloseModal()}>Cancelar</Button>
            <Button disabled={loading} onClick={() => handleSubmit()} autoFocus>
              Enviar
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openClientsModal}
          fullWidth={true}
          maxWidth={"md"}
          onClose={() => setOpenClientsModal(!openClientsModal)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {`Clientes`}
          </DialogTitle>
          <DialogContent>

          {
            clusterClients.map((client, index) => (
                <p key={index}>{client.personne.name}</p>
            ))
            }
                          
          </DialogContent>
          <DialogActions>
            <Button disabled={loading} onClick={() => setOpenClientsModal(!openClientsModal)}>fechar</Button>
          </DialogActions>
        </Dialog>
      </FixedContainer>
    </>
  );

}

export default Notification;
